import React, { useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import userProfileImage from "../../assets/images/Profile-thumbnail-small.svg";
import EGWB from "../../assets/images/EGWB-logo.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import globalFunction from "../../utils/globalFunction";
import { useSelector } from "react-redux";
import DashboardTopSearch from "../DashboardTopSearch/DashboardTopSearch";
import { Image } from "react-bootstrap";
import Notification from "../Notification/Notification";
import AdminNotification from "../Notification/AdminNotification";
import InstructorNotification from "../Notification/InstructorNotification";

const DashboardSidebar = () => {
  const [burgerSidebarActive, setBurgerSidebarActive] = useState(false);
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  const toggleSidebar = useCallback(() => {
    setBurgerSidebarActive((prev) => !prev);
  }, []);

  const closeSidebar = useCallback(() => {
    setBurgerSidebarActive(false);
  }, []);

  const studentMenuItems = [
    {
      path: "/student-dashboard",
      icon: "icon-dashboard",
      label: "Dashboard",
    },
    {
      path: "/AssessMe",
      icon: "icon-openai",
      label: "AssessMe.Ai",
    },
    {
      path: "/growth-coordinator",
      icon: "icon-openai",
      label: "Growth Coordinator",
    },
    {
      path: "/CertifyMe",
      icon: "icon-openai",
      label: "CertifyMe.Ai",
    },
    {
      path: "/student-courses",
      icon: "icon-course",
      label: "Courses",
    },
    // {
    //   path: "/student-certificates",
    //   icon: "icon-certificate",
    //   label: "Certificates",
    // },
    {
      path: "/student-requested-certificate",
      icon: "icon-certificate",
      label: "Certificates",
    },
    {
      path: "/student-attested-certificates",
      icon: "icon-attested-certificates",
      label: "Attested Certificates",
    },
  ];

  const superAdminMenuItems = [
    {
      path: "/admin-dashboard",
      icon: "icon-dashboard",
      label: "Dashboard",
    },
    {
      path: "/students",
      icon: "icon-student-stroke",
      label: "Students",
    },
    {
      path: "/instructor",
      icon: "icon-instructor ",
      label: "Instructors",
    },
    {
      path: "/admin-courses",
      icon: "icon-course",
      label: "Courses",
    },
    {
      path: "/admin-new-course",
      icon: "icon-Add",
      label: "Add New Courses",
    },
    {
      path: "/admin-organization-requests",
      icon: "icon-user-group",
      label: "Organization Requests",
    },
    {
      path: "/admin-deactivated-users",
      icon: "icon-deactivate",
      label: "Deactivated Users",
    },
    {
      path: "/admin-request-course",
      icon: "icon-course-requests",
      label: "Course Requests",
    },
    {
      path: "/admin-certificates-requests",
      icon: "icon-attested-certificates",
      label: "Certificate Requests",
    },
  ];

  const InstructorMenuItems = [
    {
      path: "/instructor-dashboard",
      icon: "icon-dashboard",
      label: "Dashboard",
    },
    {
      path: "/instructor-student",
      icon: "icon-student-stroke",
      label: "Students",
    },
    {
      path: "/instructor-courses",
      icon: "icon-course",
      label: "Courses",
    },
    {
      path: "/instructor-add-course",
      icon: "icon-Add",
      label: "Add New Courses",
    },
    {
      //unpublish course pendng requests, created course pending requests.
      path: "/instructor-request-course",
      icon: "icon-course-requests",
      label: "Course Requests",
    },
    {
      path: "/instructor-deactivated-students",
      icon: "icon-deactivate",
      label: "Deactivated Students List",
    },
    {
      path: "/instructor-certificates-requests",
      icon: "icon-certificate",
      label: "Certificate Requests",
    },
  ];

  const bottomMenuItems = [
    {
      path: "/settings",
      icon: "icon-setting",
      label: "Setting",
    },
    {
      path: "/help-center",
      icon: "icon-help",
      label: "Help Center",
    },
    {
      path: "/profile",
      icon: "icon-user",
      label: auth.full_name,
      isDivider: true,
    },
  ];

  const isActive = (path) => {
    return location.pathname === path ? "d-flex active" : "d-inline-flex";
  };

  const renderMenuItems = (items) => {
    if (!items) return null;

    return (
      <ul className="menu list-unstyled">
        {items.map((item) => (
          <React.Fragment key={`${item.path}-${item.label}`}>
            <li className="mb-10">
              {item.label === "Add New Courses" ? (
                <Link
                  to={item.path}
                  className={`menu-item align-items-center fw-semibold ${isActive(
                    item.path
                  )}`}
                  onClick={() => {
                    globalFunction.deleteCourseStorage();
                    globalFunction.deleteUploadedVideosStorage();
                    localStorage.removeItem("uploadedImages");
                    localStorage.removeItem("uploadedDocuments");
                    closeSidebar();
                  }}
                >
                  <span className="icon">
                    <i className={item.icon}></i>
                  </span>
                  <span>{item.label}</span>
                </Link>
              ) : (
                <Link
                  to={item.path}
                  className={`menu-item align-items-center fw-semibold ${isActive(
                    item.path
                  )}`}
                  onClick={closeSidebar}
                >
                  <span className="icon">
                    {item.path === "/profile" ? (
                      <>
                        <Image
                          src={
                            auth.profilePic?.startsWith("/")
                              ? process.env.REACT_APP_GALLERY_URL +
                              "/" +
                              auth.profilePic
                              : process.env.REACT_APP_GALLERY_URL +
                              auth.profilePic
                          }
                          alt="Profile"
                          className="rounded-circle object-fit-cover"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = userProfileImage;
                          }}
                        />
                      </>
                    ) : (
                      <i className={item.icon}></i>
                    )}
                  </span>
                  <span>{item.label}</span>
                </Link>
              )}
            </li>
          </React.Fragment>
        ))}
      </ul>
    );
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="sidebar d-none d-lg-flex flex-column">
        <div className="py-50 d-flex justify-content-center">
          <Link to={"/"} className="logo align-items-center d-flex gap-3">
            <LazyLoadImage src={EGWB} alt={""} effect="blur" />
            <strong className="fw-semibold pNovaFamily">
              <span>EGWB</span>
            </strong>
          </Link>
        </div>
        <div className="scrollable-sidebar d-flex flex-column justify-content-between ">
          <div>
            {renderMenuItems(
              auth.role === "Student"
                ? studentMenuItems
                : auth.role === "Admin"
                  ? superAdminMenuItems
                  : auth.role === "Instructor"
                    ? InstructorMenuItems
                    : ""
            )}
          </div>
          <div className="bottom-section">
            {renderMenuItems(bottomMenuItems)}
            <div className="sidebar-devider" />
            <div className="menu">
              <button
                type="button"
                onClick={() => globalFunction.logoutFunction()}
                style={{ marginTop: "-20px" }}
                className={`menu-item d-inline-flex align-items-center fw-semibold border-0 bg-transparent p-0 mb-20`}
              >
                <span className="icon">
                  <i className="icon-logout"></i>
                </span>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="mobile-header py-20 px-15 d-flex align-items-center justify-content-between d-lg-none">
        <Link to={"/"} className="logo align-items-center d-flex gap-3">
          <LazyLoadImage src={EGWB} alt={""} effect="blur" />
          <strong className="fw-semibold pNovaFamily">
            <span>EGWB</span>
          </strong>
        </Link>
        <div className="d-flex gap-3 gap-sm-4 align-items-center">
          <div className="search-wrapper d-none d-md-flex">
            <DashboardTopSearch />
          </div>
          {auth.role === "Student" ? <Notification /> : auth.role === "Admin" ? <AdminNotification /> : auth.role === "Instructor" ? <InstructorNotification /> : ""}
          {/* <span className="icon-bell notification-bell theme-color cursor-pointer"></span> */}
          <button
            className="bg-transparent border-0 p-0"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            <svg
              width="20"
              height="16"
              viewBox="0 0 14 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1H13M1 5H13M1 9H13"
                stroke="#f05203"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`mobile-dashboard-sidebar d-lg-none ${burgerSidebarActive ? "active" : ""
          }`}
      >
        <button
          className="close cursor-pointer p-0"
          onClick={toggleSidebar}
          aria-label="Close menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 20 19"
            fill="none"
          >
            <path
              d="M9.99934 17.8331V9.49977M9.99934 9.49977V1.16644M9.99934 9.49977H18.3327M9.99934 9.49977H1.66602"
              stroke="#fff"
              strokeWidth="2.08333"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <div className="scrollable-sidebar d-flex flex-column justify-content-between ">
          <div>
            {renderMenuItems(
              auth.role === "Student"
                ? studentMenuItems
                : auth.role === "Admin"
                  ? superAdminMenuItems
                  : auth.role === "Instructor"
                    ? InstructorMenuItems
                    : ""
            )}
          </div>
          <div className="bottom-section">
            {renderMenuItems(bottomMenuItems)}
            <div className="menu">
              <button
                type="button"
                onClick={() => {
                  globalFunction.logoutFunction();
                  closeSidebar();
                }}
                style={{ marginTop: "-20px" }}
                className={`menu-item d-flex align-items-center fw-semibold border-0 bg-transparent p-0 mb-20`}
              >
                <span className="icon">
                  <i className="icon-logout"></i>
                </span>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(DashboardSidebar);
